import React, { useMemo } from "react";
import { useHistoryDataExportGridColumns } from "./insHistoryDataExportGrid.columns";
import { InsGrid } from "components/widgets";
import { useExportDataExcelHistory, useGetExportDataExcelHistory } from "hooks/use-get-export-data-excel-history";
export const InsHistoryDataExportGrid = (props) => {
    const historyData = useExportDataExcelHistory(props?.exportType), [queryState] = useGetExportDataExcelHistory(props?.exportType);
    const rows = useMemo(() => historyData.map((data) => ({
        Description: data.description,
        ExportDate: data?.exportDate,
        Id: data.id,
        Name: data.name
    })), [historyData]);
    const columns = useHistoryDataExportGridColumns();
    return React.createElement(React.Fragment, null,
        React.createElement(InsGrid, { stateId: "history-data-export", queryState: queryState, columnDefs: columns, pagination: true, paginationPageSize: 25, rowData: rows, suppressRowClickSelection: true }));
};
